





















































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { storePernyataanPemilihanDokter } from "@/store/modules/PernyataanPemilihanDokterStore";
import PernyataanPemilihanDokterSvc from "@/services/PernyataanPemilihanDokter";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import { storeDokter } from "@/store/modules/dokter";
import { storePasien } from "@/store/modules/pasien";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { CARA_BAYAR_KELAS_3 } from "@/constants/caraBayarKelas3";

@Component({
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardPernyataanPemilihanDokter extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get caraBayarKelas3(): string | null {
    const asr = RegisterKunjungan.register?.asr;
    return (asr && CARA_BAYAR_KELAS_3[asr]) || null;
  }

  get readOnly(): boolean {
    return this.isReadOnly() || !!this.caraBayarKelas3;
  }

  get canSave(): boolean {
    if (this.readOnly) return false;
    const action = this.editingId ? "edit" : "create";
    return userModule.canAccessForm("pernyataan_pemilihan_dokter", action);
  }

  saving = false;
  formValid = false;
  editingId: number | null = null;

  form: any = this.getEmptyForm();

  mounted() {
    storePernyataanPemilihanDokter.getByRegister(this.register);
    if (!storeDokter.listAll.length) {
      storeDokter.act_dokter_all();
    }
    this.autoFillPasien();
  }

  @Watch("statePasien")
  onPasienLoaded() {
    if (!this.editingId && this.form.status_penanda_tangan === "pasien") {
      this.autoFillPasien();
    }
  }

  autoFillPasien() {
    if (this.form.status_penanda_tangan === "pasien" && this.statePasien) {
      this.form.penanda_tangan_nama = this.statePasien.nama || "";
      this.form.penanda_tangan_alamat = this.statePasien.alamat || "";
    }
  }

  getEmptyForm() {
    return {
      status_penanda_tangan: "pasien",
      penanda_tangan_nama: "",
      penanda_tangan_alamat: "",
      hubungan_keluarga: "",
      dokter_pilihan_id: null,
      tempat_tanda_tangan: "Bantul",
      tgl_tanda_tangan: localISODate()
    };
  }

  get dokterList() {
    return storeDokter.listAll;
  }

  get statePasien() {
    return storePasien.identitasPasien;
  }

  get stateList() {
    return storePernyataanPemilihanDokter.list;
  }

  formatDate(date) {
    if (!date) return "";
    const d = new Date(date);
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  }

  onStatusChange(val: string) {
    if (val === "pasien" && this.statePasien) {
      this.form.penanda_tangan_nama = this.statePasien.nama || "";
      this.form.penanda_tangan_alamat = this.statePasien.alamat || "";
      this.form.hubungan_keluarga = "";
    } else if (val === "keluarga") {
      this.form.penanda_tangan_nama = "";
      this.form.penanda_tangan_alamat = "";
    }
  }

  startEdit(item: any) {
    this.editingId = item.id;
    this.form = {
      status_penanda_tangan: item.status_penanda_tangan || "pasien",
      penanda_tangan_nama: item.penanda_tangan_nama || "",
      penanda_tangan_alamat: item.penanda_tangan_alamat || "",
      hubungan_keluarga: item.hubungan_keluarga || "",
      dokter_pilihan_id: item.dokter_pilihan ? item.dokter_pilihan.id : null,
      tempat_tanda_tangan: item.tempat_tanda_tangan || "Bantul",
      tgl_tanda_tangan: item.tgl_tanda_tangan || ""
    };
  }

  cancelEdit() {
    this.editingId = null;
    this.form = this.getEmptyForm();
    this.autoFillPasien();
  }

  async simpan() {
    if (!(this.$refs.formPernyataan as any).validate()) return;
    this.saving = true;

    try {
      const payload = {
        register_id: this.register,
        pasien_rm: this.rm,
        ...this.form,
        hubungan_keluarga: this.form.status_penanda_tangan === "keluarga"
          ? this.form.hubungan_keluarga
          : null
      };

      let resp;
      if (this.editingId) {
        resp = await PernyataanPemilihanDokterSvc.update(this.editingId, payload);
      } else {
        resp = await PernyataanPemilihanDokterSvc.create(payload);
      }

      if (resp.data.status == "1") {
        appModule.NoticeDelay("Pernyataan Pemilihan Dokter berhasil disimpan");
        this.editingId = null;
        this.form = this.getEmptyForm();
        this.autoFillPasien();
        storePernyataanPemilihanDokter.getByRegister(this.register);
      }
    } finally {
      this.saving = false;
    }
  }

  async signItem(id: number) {
    const q = confirm("Tandai bahwa dokumen ini sudah ditandatangani secara fisik?");
    if (!q) return;

    try {
      const resp = await PernyataanPemilihanDokterSvc.sign(id);
      if (resp.data.status == "1") {
        appModule.NoticeDelay("Berhasil menandai sebagai ditandatangani");
        storePernyataanPemilihanDokter.getByRegister(this.register);
      }
    } catch {
      // Error already shown by service
    }
  }

  cetakPdf(id: number) {
    PernyataanPemilihanDokterSvc.print(id);
  }

  async remove(id: number) {
    const q = confirm("Anda yakin akan menghapus pernyataan ini?");
    if (!q) return;

    try {
      const resp = await PernyataanPemilihanDokterSvc.destroy(id);
      if (resp?.status == 1) {
        appModule.NoticeDelay(resp.message);
        storePernyataanPemilihanDokter.getByRegister(this.register);
      }
    } catch {
      // Error already shown by service
    }
  }
}
